import React from "react"
import { createRoot } from "react-dom/client"
import { AppContainer } from "./AppContainer"

const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (character) => {
    const entities: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }
    return entities[character]
  })

const errorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  return String(error)
}

const renderFatalError = (error: unknown): void => {
  const root = document.getElementById("root")
  if (!root) return
  root.innerHTML = `<div class="app-fatal" role="alert">OpenReceive could not start: ${escapeHtml(errorMessage(error))}</div>`
}

const mount = (): void => {
  const rootElement = document.getElementById("root")
  if (!rootElement) return
  createRoot(rootElement).render(<AppContainer />)
}

export const startProject = (): void => {
  window.addEventListener("error", (event) => renderFatalError(event.error ?? event.message))
  window.addEventListener("unhandledrejection", (event) => renderFatalError(event.reason))

  try {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", mount)
    } else {
      mount()
    }
  } catch (error) {
    renderFatalError(error)
  }
}
